import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#FFDA44",
      d: "M10.783.498A8 8 0 0 0 8 0c-.979 0-1.916.176-2.783.498L4.522 8l.695 7.502A8 8 0 0 0 8 16c.979 0 1.916-.176 2.783-.498L11.478 8z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#D80027",
      d: "M16 8A8 8 0 0 0 10.783.498v15.005A8 8 0 0 0 16 8"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#000",
      d: "M0 8a8 8 0 0 0 5.217 7.502V.498A8 8 0 0 0 0 8"
    }, null, -1)
  ])))
}
export default { render: render }